import { render, staticRenderFns } from "./DeleteButtonWithConfirm.vue?vue&type=template&id=5eccbadc&scoped=true"
import script from "./DeleteButtonWithConfirm.vue?vue&type=script&lang=js"
export * from "./DeleteButtonWithConfirm.vue?vue&type=script&lang=js"
import style0 from "./DeleteButtonWithConfirm.vue?vue&type=style&index=0&id=5eccbadc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eccbadc",
  null
  
)

export default component.exports